import { format, parseISO } from 'date-fns';
import { AutoRenewalDetail } from './types';

/**
 * What a customer is told once a delay has gone through.
 *
 * Read off the api's answer rather than worked out here: the new date is the api's to
 * decide, and telling someone a date the server did not agree to is the kind of mistake
 * that is only found when the charge arrives.
 *
 * Its own module because both flows end in it — the delay modal, and the delay step
 * inside the disable flow — and neither should have to import the other to say it.
 */
export function delaySuccessMessage(autoRenewServiceName: string, autoRenewal?: AutoRenewalDetail): string {
  if (autoRenewal?.automatic_charge_date) {
    const date = format(parseISO(autoRenewal.automatic_charge_date), 'MMMM do, yyyy');

    return `Your ${autoRenewServiceName} renewal has been successfully delayed. You will not be charged until ${date}.`;
  }

  return `Your ${autoRenewServiceName} renewal has been successfully delayed.`;
}

export function disableSuccessMessage(autoRenewServiceName: string): string {
  return `Your ${autoRenewServiceName} renewal has been successfully disabled. You will no longer be charged.`;
}

export function offerAppliedMessage(autoRenewServiceName: string, discountedPrice?: number | null): string {
  const price = discountedPrice != null ? `of $${discountedPrice.toFixed(2)} ` : '';

  return `Your discounted price ${price}has been successfully applied to your next ${autoRenewServiceName} renewal.`;
}
